import { render, staticRenderFns } from "./InitialsAvatar.vue?vue&type=template&id=21ee13be&"
import script from "./InitialsAvatar.vue?vue&type=script&lang=ts&"
export * from "./InitialsAvatar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports